import classNames from '../../../layout/classNames';
import React from 'react';
import { useForecastingSettings } from '../../ForecastingContextProvider';
import { usePrimaryForecastingState } from '../ForecastingPanel';
import Select, {MultiValue} from 'react-select';
import InfoBox from '../InfoBox';

export type ForecastingSSP =
    | 'placeexchange'
    | 'vistar'
    | 'broadsign'
    | 'viooh'
    | 'onetechssp1'
    | 'dax'
    | 'adscale'
    | 'hivestack'
    | 'ucfunnel';

const SSPS_TO_NAMES: ReadonlyMap<ForecastingSSP, string> = new Map([
    ['broadsign', 'Broadsign'],
    ['dax', 'Dax'],
    ['hivestack', 'Hivestack'],
    ['placeexchange', 'Place Exchange'],
    ['onetechssp1', 'SSP1'],
    ['adscale', 'Stroer'],
    ['ucfunnel', 'UCFunnel'],
    ['viooh', 'VIOOH'],
    ['vistar', 'Vistar']],
);

const SINGLE_MEDIA_OWNERS: ForecastingSSP[] = ['viooh', 'dax', 'adscale'];
    
export default function SSP() {
    const { forecastingSettings, updateForecastingSetting } = useForecastingSettings();
    const { isPrimaryForecastingLoading } = usePrimaryForecastingState();

    const selectOptions = Array.from(SSPS_TO_NAMES)
        .map(([sspType, sspName]): {label: string, value:ForecastingSSP} => { return {label: sspName, value: sspType as ForecastingSSP}; });

    const defaultValue = getDefaults(forecastingSettings.ssp)
        .map(v => {
            return {value: v.value as ForecastingSSP, label: v.label};
        });
    
    return (
        <div className='mt-2 w-80'>
            <div style={{flexDirection: 'row'}}>
                <label
                    htmlFor='ssp'
                    className='inline-block text-sm font-medium text-gray-700'
                >
                    SSP
                </label>
                <InfoBox id={'ssp-info-box'}>
                    <div>
                        Forecasting against multiple multi media owner SSPs is not available currently to avoid over projection due to the non-existence of a unified screen ID across partners.
                    </div>
                </InfoBox>
            </div>
            <Select
                key={'ssp'}
                isDisabled={isPrimaryForecastingLoading || !forecastingSettings.ssp}
                menuPortalTarget={document.body}
                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                isMulti
                name='ssp'
                className='basic-multi-select'
                classNamePrefix='select'
                onChange={(newValue: MultiValue<{
                    label: string,
                    value: ForecastingSSP
                }>) => updateForecastingSetting({ publisherFilter: null, ssp: newValue.map(c => c.value as ForecastingSSP) })}
                options={selectOptions}
                isOptionDisabled={(option) => isSSPDisabled(option.value, forecastingSettings.ssp)}
                defaultValue={defaultValue}
            />
        </div>
    );
}

function isSSPDisabled(ssp: ForecastingSSP, currentlySelected: ForecastingSSP[]): boolean {
    if (SINGLE_MEDIA_OWNERS.includes(ssp) || currentlySelected.length == 0) {
        return false;
    }
    for (let i = 0; i < currentlySelected.length; i++) {
        if (!SINGLE_MEDIA_OWNERS.includes(currentlySelected[i])) {
            return true;
        }
    }
    return false;
}

function getDefaults(values: ForecastingSSP[]) {
    return values.map(v => {
        return { label: SSPS_TO_NAMES.get(v) ?? '', value: v };
    });
};